import {callModal} from "./modal";

export const modalBus = $({});
modalBus.on('callModal', (ev, dataAction) => {
  callModal(dataAction);
});
